import { usePkce } from '@oliasoft/pkce';
import httpClient from '~utils/httpClient';

export default function useLogout() {
  const auth = usePkce();

  const apiLogout = async () => {
    return httpClient({
      method: 'get',
      url: '/api/logout',
      baseURL: '/',
    });
  };

  const handleLogout = async () => {
    await apiLogout();
    localStorage.clear();
    await auth.logout();
  };

  return handleLogout;
}
